// Simple event emitter for auth-related events
type AuthEventCallback = () => void;

const listeners: Set<AuthEventCallback> = new Set();

export const authEvents = {
  subscribe: (callback: AuthEventCallback) => {
    listeners.add(callback);
    return () => listeners.delete(callback);
  },

  emitLogout: () => {
    listeners.forEach((callback) => callback());
  },
};
